
import Main from "./index";

export default class MainView extends Main {}
